import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { primaryRed, hoverColor } from 'styles/variables'
import { LinearProgress } from '@material-ui/core'
import classNames from 'classnames'

const useStyles = makeStyles(() => ({
  colorPrimary: {
    backgroundColor: primaryRed,
  },
  barColorPrimary: {
    backgroundColor: hoverColor
  },
  container: {
    padding: '24px 0 32px',
    width: '310px'
  }
}))

export function LinearLoader ({ className }) {
  const { container, ...classes } = useStyles()

  return (
    <div className={classNames(container, className)}>
      <LinearProgress classes={{ ...classes }}/>
    </div>
  )
}
